export default function ExternalLinkIcon() {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.6665 7.83385L14.1332 2.36719"
        stroke="#4F55FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6668 5.03398V1.83398H11.4668"
        stroke="#4F55FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.3335 1.83398H6.00016C2.66683 1.83398 1.3335 3.16732 1.3335 6.50065V10.5007C1.3335 13.834 2.66683 15.1673 6.00016 15.1673H10.0002C13.3335 15.1673 14.6668 13.834 14.6668 10.5007V9.16732"
        stroke="#4F55FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
